import { render, staticRenderFns } from "./off.eventos-modal.vue?vue&type=template&id=1370d358&"
import script from "./off.eventos-modal.vue?vue&type=script&lang=js&"
export * from "./off.eventos-modal.vue?vue&type=script&lang=js&"
import style0 from "./off.eventos-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports